import React, { useState, useEffect, startTransition } from 'react'
import { TabPanel } from '../../Components/Tab/TabPanel'
import { DraftTable } from './DraftTable'
import { DraftPick } from '../../Api/Draft/draft.types'
import { Spinner } from '../../Components/Icons'
import { colors } from '../../Components/consts'
import { Con } from '../../Components/Layout/Containers/ConStyles'
import { TabHeaderStyle } from '../../Components/Tab/styles'
import { Tab } from '../../Components/LazyComponents'
import { useDraftContext } from '../../Context/DraftContext/DraftContext'
import { DRAFT_YEAR } from '../../Config/League/league.config'
import { DraftBoardView } from './DraftBoard/DraftBoardView'

type DraftParams = {
  year: number
}

export const DraftTabs: React.FC<DraftParams> = ({ year }) => {
  const { currentYearDraftPicks, prevDraftPicks, isLoading } = useDraftContext()
  const [value, setValue] = useState(0)
  const [rounds, setRounds] = useState<number[]>([])
  const [draftPicks, setDraftPicks] = useState<DraftPick[]>([])

  useEffect(() => {
    if (year === DRAFT_YEAR && currentYearDraftPicks.length > 0) {
      setDraftPicks(currentYearDraftPicks)
      getTotalRounds(currentYearDraftPicks)
    }
    if (year !== DRAFT_YEAR && prevDraftPicks && year in prevDraftPicks) {
      setDraftPicks(prevDraftPicks[year])
      getTotalRounds(prevDraftPicks[year])
    }
  }, [currentYearDraftPicks, prevDraftPicks])

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    if (newValue !== value) {
      startTransition(() => {
        setValue(newValue)
      })
    }
  }

  const getTotalRounds = (picks: DraftPick[]) => {
    let prevRound: number
    let rds: number[] = []
    picks.map((pk) => {
      if (pk.round !== prevRound) {
        rds.push(pk.round)
        prevRound = pk.round
        return
      }
    })
    setRounds(rds)
  }

  const filterRoundPicks = (round: number) => {
    let pks = [...draftPicks]
    let roundPks = pks.filter((pk) => pk.round === round)
    return roundPks
  }

  if (isLoading) {
    return (
      <Con justify="center" noMargin noPadding>
        <div>
          <Spinner fill={colors.yellow} />
          Loading...
        </div>
      </Con>
    )
  }

  return (
    <>
      <TabHeaderStyle
        tabColor="light"
        topRadius={8}
        value={value}
        onChange={handleChange}
        aria-label="draft tabs"
        variant="scrollable"
        scrollButtons={false}
      >
        {rounds.length > 1 &&
          rounds.map((rd, idx) => <Tab label={`RD ${rd}`} key={rd + idx} />)}
        {year === DRAFT_YEAR && <Tab label={'Board'} key={'Board'} />}
      </TabHeaderStyle>
      {rounds.length > 1 &&
        rounds.map((rd, idx) => (
          <TabPanel key={idx} value={value} index={idx}>
            <DraftTable picks={filterRoundPicks(rd)} />
          </TabPanel>
        ))}
      {year === DRAFT_YEAR && (
        <TabPanel key={'Board'} value={value} index={rounds.length}>
          <DraftBoardView showProfilePicture={false} fullHeight={false} />
        </TabPanel>
      )}
    </>
  )
}
